import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { IncomeTaxPersonalChildFederalOptions } from '../federal/income-tax-personal-child-federal.options';
import {CalculationDate} from '../../../../../models/calculation.date';
import {IncomeTaxPersonalChildCampOptions} from '../common/income-tax-personal-child-camp.options';

@translationBaseKey('income-tax-personal-child-federal-in-income-tax-personal-options')
export class IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions implements Omit<IncomeTaxPersonalChildFederalOptions,
  'firstName' |
  'lastName' |
  'birthdate' |
  'camps' |
  'id' |
  'isDisabled' |
  'name' |
  'netIncome' |
  'isLivingWithYou' |
  'numberOfFullTimeMonthsAtSchool'> {
  @clonePropertyMetadata<IncomeTaxPersonalChildFederalOptions>(IncomeTaxPersonalChildFederalOptions, 'careExpensesOthers')
  careExpensesOthers: number;
}
